<p-dialog modal="true" appendTo="body" [(visible)]="display" [resizable]="false" (onHide)="onDialogHide()"
		  [style]="{'width': '550px', 'minWidth': '500px'}">

	<p-header>
		<span>Share Privileges</span>
	</p-header>

	<div style="display: grid; grid-template-columns: 1fr 1fr;">
		<span>
			<input type="checkbox" [(ngModel)]="canEnableDisablePorts" />
			<span class="uv-checkbox-label">Enable/Disable Ports</span>
		</span>
		<span>
			<input type="checkbox" [(ngModel)]="canManagePortPoe" />
			<span class="uv-checkbox-label">Manage Port POE</span>
		</span>
		<span>
			<input type="checkbox" [(ngModel)]="canEditPortAliases" />
			<span class="uv-checkbox-label">Edit Port Aliases</span>
		</span>
		<span>
			<input type="checkbox" [(ngModel)]="canManagePortAccessVlans" />
			<span class="uv-checkbox-label">Manage Port Access VLANs</span>
		</span>
		<span>
			<input type="checkbox" [(ngModel)]="canManageTrunkedVlans" />
			<span class="uv-checkbox-label">Manage Trunked VLANs</span>
		</span>
		<span>
			<input type="checkbox" [(ngModel)]="canViewConfigs" />
			<span class="uv-checkbox-label">View/Compare Configs</span>
		</span>
		<span>
			<input type="checkbox" [(ngModel)]="canManageAgents" />
			<span class="uv-checkbox-label" title="Add/Edit/Delete agents for network">Manage Agents</span>
		</span>
	</div>

	<p-footer>
		<button type="button" pButton icon="fa fa-check" (click)="handleOK()" label="OK" [disabled]="!enableOK"></button>
		<button type="button" pButton icon="fa fa-close" (click)="handleCancel()" label="Cancel"></button>
	</p-footer>

</p-dialog>
